<template>
  <van-popup :value="value" @input="onInput" round >
    <div class="flex flex-col items-center text-center">
      <div class="flex flex-col items-center brand-info-wrap  bg-white">
        <span>Brand Info</span>

        <van-field v-model="form.brandName" placeholder="Enter Brand"/>

        <div class="upload-image-wrap flex flex-col items-center justify-center relative" @click="onChooseImageClick">
          <van-image class="default-brand-img" :class="isAdd ? '-mt-8':''" :src="form.brandImage" fit="contain"/>
          <span v-if="isAdd" class="absolute bottom-2  text-12px third-color">148px * 148px</span>
        </div>
        <div class="flex flex-row items-center  mt-4  w-full gap-3">
          <div class="delete-back-btn flex-1 radius-border" @click="onDeleteClick">{{ deleteText }}</div>
          <div class="bottom-back-btn flex-1" @click="onSubmitClick">{{ buttonText }}</div>
        </div>

      </div>
      <img src="../../assets/icons/v2/icon_popup_close.png" class="w-9 h-9 mt-6 p-2" @click="onInput(false)"/>
    </div>
  </van-popup>
</template>

<script>
import { Toast } from "vant";
import user from "@/api/user";
import produce from "@/api/produce";

export default {
  name: "PopupBrandInfo",
  props: {
    isAdd: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: "Submit"
    },
    deleteText: {
      type: String,
      default: "Submit"
    },
    value: {
      type: Boolean,
      default: false
    },

    brandInfo: {
      type: Object,
      default: () => {
        return {
          brandPicture: "",
          brandName: ""
        };
      }
    }
  },
  data() {
    return {
      form: {
        brandName: "",
        brandImage: ""
      },
      selectedFile: ""
    };
  },
  methods: {
    onInput(show) {
      this.$emit("input", show);
    },
    async onChooseImageClick() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = async e => {
        const file = e.target.files[0];
        if (file) {
          this.selectedFile = file;
          const selectedImage = URL.createObjectURL(file);
          this.form.brandImage = selectedImage;
        }
      };
      input.click();
    },
    async onDeleteClick() {
      this.$emit('onDeleteClick')
    },
    async onSubmitClick() {
      try {
        let brandUrl = this.form.brandImage;
        const file = this.selectedFile;
        const isAdd = this.isAdd;

        if (!this.form.brandName) {
          this.$toast({
            type: "fail",
            message: "Brand name required",
            duration: "1000",
            position: "center"
          });
          return;
        }

        if (isAdd && !file) {
          this.$toast({
            type: "fail",
            message: "Brand icon required",
            duration: "1000",
            position: "center"
          });
          return;
        }

        if (file) {
          const formData = new FormData();
          formData.append("file", file);
          Toast.loading("Uploading");
          brandUrl = await user.uploadFile(formData);
        }

        let resp = { message: "" };
        if (isAdd) {

          resp = await produce.addBrand({
            brandName: this.form.brandName,
            brandPicture: brandUrl,
            id: this.brandInfo.id
          });
          this.$emit("onUpdateBrandList");

        } else {
          resp = await produce.modifyBrand({
            brandName: this.form.brandName,
            brandPicture: brandUrl,
            id: this.brandInfo.id
          });


          const brandInfo = Object.assign({}, this.brandInfo);
          brandInfo.brandPicture = brandUrl;
          brandInfo.brandName = `${this.form.brandName}`;
          this.$emit("onUpdateBrandInfo", brandInfo);
        }

        this.$emit("input", false);
        this.$toast({
          message: resp.message,
          duration: "1000",
          position: "center"
        });
        this.selectedFile = null;
      } catch (err) {
        Toast.fail("Upload avatar fail!" + err);
      } finally {
      }
    }

  },
  watch: {
    brandInfo(b) {
      this.form.brandName = b.brandName;
      this.form.brandImage = b.brandPicture;
    },
    value(newVal) {
      if (newVal) {
        this.form.brandName = this.brandInfo.brandName;
        this.form.brandImage = this.brandInfo.brandPicture;
      }
    }
  },
  mounted() {
    this.form.brandName = this.brandInfo.brandName;
    this.form.brandImage = this.brandInfo.brandPicture;
  }
};
</script>

<style scoped lang="less">
.brand-info-wrap {
  border-radius: 12px;
  background: white;
  padding: 1.33rem;
  width: 20rem;
  height: 23rem;
}
::v-deep .van-cell {
  padding: 0 16px;
}
::v-deep .van-field {
  margin-top:16px;
  border: 1px solid #E8E8E8;
  border-radius: 12px;
}
::v-deep .van-field__value {
  box-sizing: border-box;
  input {
    padding: 0 !important;
  }
}

.upload-image-wrap {
  border: 1px #E8E8E8 solid;
  width: 8.5rem;
  height: 8.5rem;
  border-radius: 1rem;
  margin-top: 1.33rem;
}

.default-brand-img {
  width: 4rem;
  height: 4rem;
}

.van-popup {
  background: transparent;
}
::v-deep .van-cell::after {
  border: none;
}
</style>